// extracted by mini-css-extract-plugin
module.exports = {"root":"_1cD1-","separator":"_2OYn5","link":"_3LDhC","list":"_2OqIW","name":"_3o55k"};